var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":""}},[_c('AvatarIconMenu'),_c('v-card-subtitle',{staticClass:"d-flex flex-column grey--text pt-0"},[_c('span',{staticClass:"font-weight-medium text-h6"},[_vm._v(" "+_vm._s(_vm.user.fullName)+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.user.email)+" ")])]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }